import { render, staticRenderFns } from "./SubjectsReferredTable.vue?vue&type=template&id=2ab0d9c8&"
import script from "./SubjectsReferredTable.vue?vue&type=script&lang=js&"
export * from "./SubjectsReferredTable.vue?vue&type=script&lang=js&"
import style0 from "./SubjectsReferredTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports